module.exports = __webpack_public_path__ + "img/playstore.1748801e.png";